// Login bridge. Kicks the user straight to the server-side /auth/login flow,
// which redirects through WorkOS and back to /auth/callback to set the
// sealed-session cookie. Avoids AuthKit React's client-side signIn() because
// of the 400 invalid_grant rotation-race pattern (see workos-no-force-refresh).
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

export default function Login() {
  const [params] = useSearchParams()
  const next = params.get('next') || '/admin'
  useEffect(() => {
    // Persist the post-sign-in destination so the home page can route back.
    window.location.assign('/auth/login?next=' + encodeURIComponent(next))
  }, [next])
  return <div className="p-10 text-ink-3 text-sm">Redirecting to sign in…</div>
}
